import { render, staticRenderFns } from "./header.vue?vue&type=template&id=4fdc5c0e&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=4fdc5c0e&prod&scoped=true&lang=css"
import style1 from "./header.vue?vue&type=style&index=1&id=4fdc5c0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdc5c0e",
  null
  
)

export default component.exports